import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const IconSvg = () => (
  <svg
    width="14"
    height="18"
    viewBox="0 0 14 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5217 17.1507C12.4931 17.1541 12.4646 17.1562 12.4367 17.1562C12.0989 17.1562 11.806 16.9047 11.7631 16.5608C11.4518 14.0711 9.53786 12.3984 6.99992 12.3984C4.46198 12.3984 2.54799 14.0711 2.23669 16.5608C2.1898 16.9332 1.84724 17.1983 1.47817 17.1507C1.1057 17.1045 0.841304 16.7647 0.888202 16.3922C1.28242 13.2405 3.79521 11.039 6.99992 11.039C10.2046 11.039 12.7181 13.2405 13.1116 16.3922C13.1579 16.7647 12.8941 17.1045 12.5217 17.1507ZM1.90229 5.60154C1.90229 5.22635 2.20679 4.92185 2.58197 4.92185H2.92182V4.58201C2.92182 2.52053 4.5986 0.84375 6.66008 0.84375L7.33976 0.84375C9.40124 0.84375 11.078 2.52053 11.078 4.58201V4.92185H11.4179C11.793 4.92185 12.0975 5.22635 12.0975 5.60154C12.0975 5.97672 11.793 6.28122 11.4179 6.28122H11.078C11.078 8.53029 9.24899 10.3593 6.99992 10.3593C4.75084 10.3593 2.92182 8.53029 2.92182 6.28122H2.58197C2.20679 6.28122 1.90229 5.97672 1.90229 5.60154ZM9.71865 6.28122L4.28118 6.28122C4.28118 7.7806 5.50054 8.99996 6.99992 8.99996C8.4993 8.99996 9.71865 7.7806 9.71865 6.28122ZM4.28118 4.92185L9.71865 4.92185V4.58201C9.71865 3.38577 8.83099 2.39275 7.6796 2.22759V3.56249C7.6796 3.93767 7.3751 4.24217 6.99992 4.24217C6.62473 4.24217 6.32023 3.93767 6.32023 3.56249V2.22759C5.16885 2.39275 4.28118 3.38577 4.28118 4.58201V4.92185Z"
      className="iconBorder"
    />
  </svg>
);

const SubContractorIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={IconSvg} {...props} />
);

export default SubContractorIcon;
